export const HYPERWALLET_ABOUT_LINK = 'https://www.hyperwallet.com/'

export const BOOTSTRAP_LINK = {
  rel: 'stylesheet',
  href: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
  integrity:
    'sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u',
  crossorigin: '',
}
